import React from 'react';

import { ENTER } from '../util/remoteButtons';
import { fireAnalytics } from './utils';


export class Error extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            connection: false,
        }
        this.exitTimeout = null;
        this.connectionInterval = null;
    }

    componentDidMount() {
        clearInterval(this.onlineStatusInterval);
        fireAnalytics("Page", "Error Page Loaded");
        // this.exitTimeout = setTimeout(() => {
        //     window.open("", "_self").close();
        // }, 60000);
        var relaunch = this.refs.relaunch;
        relaunch.focus();
        this.connectionInterval = setInterval(() => {
            this.checkConnection();
        }, 15000);
    }

    checkConnection() {
        var condition = navigator.onLine ? true : false;
        if (condition === true) {
            // clearTimeout(this.exitTimeout);
            fireAnalytics("Network", "Network Back Online, Navigating to Player");
            clearInterval(this.connectionInterval);
            this.props.history.push(`/`);
        }
        else {
            this.setState({ connection: true });
            setTimeout(() => {
                this.setState({ connection: false });
            }, 3000);
        }
        return;
    }

    render() {
        return (
            <div className="Wrapper" style={{ textAlign: 'center' }}>
                <div className="ErrorWrapper">
                    <img className="ErrorLogo" src="assets/img/blackdove-logo-2020.png" alt=""  style={window.innerWidth <= window.innerHeight ? { paddingTop: '50%' } : { paddingTop: '10%' }} />
                    <span className="ErrorInfo">
                        Network Interruption Detected
                        <br />
                        <br />
                        To Exit the app, press EXIT Key on Remote Controller.
                        {/* <br />
                        Else, the app will EXIT automatically after 60 seconds. */}
                        <br />
                        OR
                        <br />
                        To Launch the app again, press OK key on Remote Controller.
                    </span>
                </div>
                <div
                    ref="relaunch"
                    onKeyDown={(e) => {
                        e.stopPropagation();
                        if (e.which === ENTER) { this.checkConnection(); }
                    }}
                    tabIndex="1"
                    className="btn btn--round btn--dark btn--fill relaunch"
                >Relaunch
                    </div>
                    <div className="timedPopup" style={!this.state.connection ? { opacity: '0' } : { opacity: '1' }} >No Network Connection</div>
            </div>
        );
    }
}

export default Error;
